import {
  createAsyncThunk,
  createSlice,
  isRejectedWithValue,
} from '@reduxjs/toolkit';
import instance from '../../api/axios/utils.ts/instance';
import { AxiosParamType } from '.';
import { RootState } from '..';

interface PointState {
  status: string;
  /** 포인트 잔액 */
  balance: number;
  /** 포인트 사용 차단 여부 (이벤트 등 운영 정책에 의해 차단될 수 있음) */
  blocked: boolean;
  /** 사용 차단 이유 (blocked가 false이면 null) */
  blockMessage: string | null;
}

const initialState: PointState = {
  status: '',
  balance: 0,
  blocked: false,
  blockMessage: null,
};

export const pointSlice = createSlice({
  name: 'point',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPoint.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(getPoint.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        state.balance = action.payload.point;
        state.blocked = action.payload.blocked;
        state.blockMessage = action.payload.blockMessage;
      })
      .addCase(getPoint.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getPoint = createAsyncThunk(
  'asyncThunk/getPoint',
  async ({ url, params }: AxiosParamType) => {
    try {
      const response = await instance.get(url, { params });
      return response.data;
    } catch (error) {
      console.error('[axios] getPoint : ', error);
      return isRejectedWithValue(error);
    }
  },
);

export const selectPointBalance = (state: RootState) => state.point.balance;
export const selectPointBlocked = (state: RootState) => state.point.blocked;
export const selectPointBlockMessage = (state: RootState) =>
  state.point.blockMessage;

export default pointSlice.reducer;
